import {
  GET_TRAINING_PROGRAMS_API,
  UPDATE_TRAINING_PROGRAM_API,
  DELETE_TRAINING_PROGRAM_API,
  CREATE_TRAINING_PROGRAM_API,
  GET_TRAINING_PROGRAM_BY_ID_API,
  TRAINING_API,
  GET_TRAINING_PROGRAM_ATTENDANCE,
  UPDATE_TRAINING_PROGRAM_ATTENDANCE,
} from "constants/ApiConstant";
import axiosInstance from "auth/FetchInterceptor";
const trainingProgramService = {};

trainingProgramService.Get = function (data) {
  return axiosInstance.post(`${GET_TRAINING_PROGRAMS_API}`, data);
};
trainingProgramService.GetById = function (data) {
  return axiosInstance.get(`${GET_TRAINING_PROGRAM_BY_ID_API}?id=${data}`);
};

trainingProgramService.getProgramAttendance = function (data) {
  return axiosInstance.post(GET_TRAINING_PROGRAM_ATTENDANCE, data);
};

trainingProgramService.Update = function (data) {
  return axiosInstance.put(`${UPDATE_TRAINING_PROGRAM_API}`, data);
};

trainingProgramService.UpdateDetail = function (data) {
  return axiosInstance.put(`${UPDATE_TRAINING_PROGRAM_API}-detail`, data);
};

trainingProgramService.UpdateProgramAttendance = function (data) {
  return axiosInstance.put(`${UPDATE_TRAINING_PROGRAM_ATTENDANCE}`, data);
};

trainingProgramService.Create = function (data) {
  return axiosInstance.post(`${CREATE_TRAINING_PROGRAM_API}`, data);
};
trainingProgramService.Delete = function (data) {
  return axiosInstance.delete(`${DELETE_TRAINING_PROGRAM_API}?id=${data}`);
};

trainingProgramService.SendNoti = function (data) {
  return axiosInstance.get(`${TRAINING_API}/send-noti?id=${data}`);
};

trainingProgramService.import = function (data) {
  return axiosInstance.get(
    `${TRAINING_API}/import-course-result?transId=${data.transId}&programId=${data.programId}`
  );
};

trainingProgramService.updateImport = function (data) {
  return axiosInstance.post(`${TRAINING_API}/update-import`, data);
};

trainingProgramService.getImportById = function (id) {
  return axiosInstance.get(`${TRAINING_API}/get-import-by-id?transId=${id}`);
};

export default trainingProgramService;
